import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    TelNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    CellNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    LoyaltyNumber: {
      validations: []
    },
    Reference: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    Operation: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    EventExtra10: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    }, 
    EndTime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    PlannedGuestCount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'}
      ]
    },
    Comments: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    Notes: {
      validations: []
    },
    Website: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'FirstName'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Primary Phone *',
            mapping: 'TelNumber'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Secondary Phone',
            mapping: 'CellNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Rewards Number',
            mapping: 'LoyaltyNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us? *',
            options:[
              {label: 'Email Marketing' , value: 'Email Marketing'},
              {label: 'Facebook' , value: 'Facebook'},
              {label: 'Instagram' , value: 'Instagram'},
              {label: 'Internet Search' , value: 'Internet Search'},
              {label: 'Mailer' , value: 'Mailer'},
              {label: 'Repeat Client' , value: 'Repeat Client'},
              {label: 'Website' , value: 'Website'},
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Restaurant Location *',
            options: [
              {label: 'Smoke Daddy - Wicker Park', value: 'Smoke Daddy - Wicker Park'},
              {label: 'Smoke Daddy - Wrigley', value: 'Smoke Daddy - Wrigley'},
              {label: 'Crosby\'s Kitchen', value: 'Crosby\'s Kitchen'},
            ],
            mapping: 'Operation'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Holiday Order Pick Up Date *',
            options: [
              { label: 'Tuesday 11/26/2019', value: 'Tuesday 11/26/2019' },
              { label: 'Wednesday 11/27/2019', value: 'Wednesday 11/27/2019' },
            ],
            mapping: 'EventExtra10'
      },
      {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Time *',
            options: [
              { label: '9:00 AM', value: '9:00:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '8:00 PM', value: '20:00:00' },
            ],
            mapping: 'EndTime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests *',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Requested Menu Items *',
            mapping: 'Comments'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Event Notes',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: '4 Star Restaurant Group Holiday Menu',
    formId: '613',
    clientKey: '9835D68F-2024-4842-B8E8-44097B54CB27',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/4starrestaurantgroup2/form_structure.js